import "./MessagingRulesPage.css";

const RULES: { title: string; body: string }[] = [
  {
    title: "Content Standards",
    body: "Messages must not contain any abusive language, threats, or promotion of products that are inappropriate for general adult audiences, such as adult products or narcotics.",
  },
  {
    title: "Language Requirements",
    body: "Use of Banglish or phonetic SMS (e.g., Amar, Ami, Tumi) is strictly prohibited. OTP messages should be sent in Bangla to ensure successful delivery. All SMS, except OTPs, including marketing, promotional, notification, and greeting messages, must be sent in Bangla. Accounts sending messages solely in English will be suspended. Sending combined Bangla and English words is permitted.",
  },
  {
    title: "Personal Use Prohibition",
    body: "Personal use of the SMS service, such as sending messages to friends or any romantic, adult, abusive, or threatening content, is strictly forbidden. Violation will result in immediate account suspension without the possibility of appeal. Personal SMS, including those sent to your own number, are prohibited.",
  },
  {
    title: "User Responsibility",
    body: "Users are fully responsible for all messages sent from their accounts. Misuse of the SMS service for unlawful purposes will result in legal action.",
  },
  {
    title: "Political Messaging",
    body: "All political SMS messaging is prohibited without prior authorization. However, election campaign messages may be sent in accordance with BTRC regulations.",
  },
  {
    title: "Enforcement & Monitoring",
    body: "Accounts suspended due to violations will not be refunded. All SMS traffic is monitored, and the provider reserves the right to suspend accounts without prior notice for non-compliance. These terms apply to all phone numbers associated with the account, including the user's own numbers.",
  },
];

const MessagingRulesPage = () => {
  return (
    <section className="msg-rules">
      <h2 className="msg-rules__title">Rules and Regulation</h2>
      <p className="msg-rules__intro">
        Please read the following rules carefully. They apply to all messaging
        activity from your account.
      </p>
      <div className="msg-rules__list">
        {RULES.map((rule) => (
          <article className="msg-rules__item" key={rule.title}>
            <h3 className="msg-rules__item-title">{rule.title}</h3>
            <p className="msg-rules__item-body">{rule.body}</p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default MessagingRulesPage;
